module.exports = __webpack_public_path__ + "img/DE02854.afe9f20d.png";